const header = document.querySelector("[data-header]");
const menuButton = document.querySelector("[data-menu-toggle]");
const menu = document.querySelector("[data-menu]");

const syncHeader = () => {
  header?.classList.toggle("is-scrolled", window.scrollY > 30);
};

syncHeader();
window.addEventListener("scroll", syncHeader, { passive: true });

const closeMenu = () => {
  menu?.classList.remove("is-open");
  header?.classList.remove("menu-open");
  menuButton?.setAttribute("aria-expanded", "false");
  menuButton?.setAttribute("aria-label", menuButton.dataset.labelOpen);
  document.body.style.overflow = "";
};

menuButton?.addEventListener("click", () => {
  const willOpen = !menu?.classList.contains("is-open");
  menu?.classList.toggle("is-open", willOpen);
  header?.classList.toggle("menu-open", willOpen);
  menuButton.setAttribute("aria-expanded", String(willOpen));
  menuButton.setAttribute("aria-label", willOpen ? menuButton.dataset.labelClose : menuButton.dataset.labelOpen);
  document.body.style.overflow = willOpen ? "hidden" : "";
});

menu?.querySelectorAll("a").forEach((link) => link.addEventListener("click", closeMenu));

document.addEventListener("keydown", (event) => {
  if (!menu?.classList.contains("is-open")) return;
  if (event.key === "Escape") {
    closeMenu();
    menuButton?.focus();
  }
  if (event.key === "Tab") {
    const controls = [menuButton, ...menu.querySelectorAll("a")].filter(Boolean);
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
});

window.matchMedia("(min-width: 901px)").addEventListener("change", (event) => {
  if (event.matches) closeMenu();
});

document.querySelectorAll("[data-year]").forEach((year) => { year.textContent = new Date().getFullYear(); });

document.querySelectorAll("[data-accordion]").forEach((accordion) => {
  accordion.querySelectorAll("details").forEach((item) => {
    item.addEventListener("toggle", () => {
      if (!item.open) return;
      accordion.querySelectorAll("details").forEach((other) => {
        if (other !== item) other.open = false;
      });
    });
  });
});

document.querySelectorAll('[data-product-form]').forEach(form => {
  const variants = form.querySelector('[name="id"]');
  const price = form.querySelector('[data-current-price]');
  variants?.addEventListener('change', () => {
    if (price) price.textContent = variants.selectedOptions[0]?.dataset.price || '';
  });
});
